import { useEffect, useRef } from 'react'
import { useToast } from '@chakra-ui/react'
import moment from 'moment'
import useConfigList from '../../../../hooks/useConfigList'
import useNavigateNext from '../../../../hooks/useNavigateNext'
import useUpdateReportDoc from '../../../../hooks/useUpdateReportDoc'
import useReportDocId from '../../../../hooks/useReportDocId'
import useStore, { MonthlyReport } from '../../../../store/useStore'

export const useDietFormState = () => {
  const items = useConfigList('diets')
  const navNext = useNavigateNext()
  const updateReport = useUpdateReportDoc()
  const month = useReportDocId()
  const toast = useToast()
  const hasPrefilled = useRef(false)
  const reports = useStore((s) => s.reports)

  useEffect(() => {
    if (hasPrefilled.current) return
    const currentReport = reports[month]
    const needsWater =
      !currentReport?.waterType || currentReport?.waterAmount == null
    const needsMacros = !currentReport?.macros?.protienGrams
    if (!needsWater && !needsMacros) {
      hasPrefilled.current = true
      return
    }
    const prevMonths = [1, 2, 3].map((i) =>
      moment(`${month}-15`).subtract(i, 'month').format('YYYY-MM'),
    )
    const anyPrevLoaded = prevMonths.some((m) => reports[m] !== undefined)
    if (!anyPrevLoaded) return
    const prefill: Partial<MonthlyReport> = {}
    if (needsWater) {
      for (const pm of prevMonths) {
        const prev = reports[pm]
        if (prev?.waterType && prev?.waterAmount != null) {
          prefill.waterType = prev.waterType
          prefill.waterAmount = prev.waterAmount
          break
        }
      }
    }
    if (needsMacros) {
      for (const pm of prevMonths) {
        const prev = reports[pm]
        if (prev?.macros?.protienGrams) {
          prefill.macros = prev.macros
          break
        }
      }
    }
    hasPrefilled.current = true
    if (Object.keys(prefill).length > 0) {
      updateReport(prefill)
    }
  }, [reports, month]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    const report = useStore.getState().reports[month]
    const missing: string[] = []
    if (!report?.macros?.protienGrams) missing.push('Grams of Protein')
    if (!report?.macros?.fatGrams) missing.push('Grams of Fat')
    if (report?.macros?.carbGrams == null)
      missing.push('Grams of Net Carbohydrates')
    if (!report?.waterConfirmed) missing.push('water intake confirmation')
    if (!report?.macrosConfirmed) missing.push('macros confirmation')
    if (missing.length > 0) {
      toast({
        title: 'Required fields missing',
        description: `Please complete: ${missing.join(', ')}`,
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
      return
    }
    updateReport({ diets: true })
    navNext()
  }

  const lists = [
    {
      fieldId: 'dietId',
      label: 'Diet',
      items,
      id: 'diets',
    },
  ]

  return {
    handleSubmit,
    lists,
  }
}
